<template>
  <b-col md="12" sm="12" v-if="regimentoAtivo">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <h1 tabindex="0">Fórum</h1>
      </b-card-body>
    </b-card>
    <b-card no-body class="mx-4">
      <b-card-body class="p-8">
        <b-row>
          <b-col>
            <b-card class="card-button" style="height: 170px; background-color: #F05A28; font-size: 20px; vertical-align: middle; cursor: pointer;">
              <h4>Caderno de Propostas</h4><br>
              <h4><strong>1º Momento</strong></h4>
              <b-button block variant="secondary" @click="navigate('/proposta-entrada')">
                <span>Acessar Aqui</span>
              </b-button>
            </b-card>
          </b-col>
          <b-col>
            <b-card class="card-button"  style="height: 170px; background-color: #FAAF40;  font-size: 20px; vertical-align: middle; cursor: pointer;">
              <h4>Caderno de Propostas</h4><br>
              <h4><strong>2º Momento</strong></h4>
              <b-button block variant="secondary" @click="navigate('/propostasegunda-entrada')">
                <span>Acessar Aqui</span>
              </b-button>
            </b-card>
          </b-col>
          <b-col>
            <b-card class="card-button"  style="height: 170px; background-color: #4BBCA7;  font-size: 20px; vertical-align: middle; cursor: pointer;">
              <h4>Caderno de Propostas</h4><br>
              <h4><strong>3º Momento</strong></h4>
              <b-button block variant="secondary"  @click="navigate('/propostaterceira-entrada')">
                <span>Acessar Aqui</span>
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-col>
  <b-col md="12" sm="12" v-else>
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <h3>No momento, não existe caderno de propostas para seu eixo de atuação.</h3>
      </b-card-body>
    </b-card>
  </b-col>
</template>

<script>
import Pagination from '@/components/shared/Pagination'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    Pagination,
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
        required
      }
    }
  },
  data () {
    return {
      loading: false,
      form: {
        id: '',
        titulo: '',
        descricao: '',
        eixo: ''
      },
      regimentoAtivo: true,
      resourceSugestao: '',
      resourceComentario: '',
      modalSugestaoEdicao: false,
      modalSugestaoExclusao: false,
      modalComentario: false,
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false
    }
  },
  methods: {
    abrirCaderno (caderno) {
      this.navigate('/proposta/contribuir/' + caderno)
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/caderno/Forum.vue